import React from 'react';
import ReactPaginate from 'react-paginate';

/**
 * @param {number} [totalPages=1] (=pageCount) общее кол-во страниц
 * @param {number} currentPage (=forcePage) текущая страница
 * @param {(page) => void} onPageChange функция на клик НЕ выбранной страницы, где page 0 = первая страница
 * @params ...reactPaginateProps
 */
export const SimplePaginate = React.memo(({
  totalPages = 1,
  currentPage,
  onPageChange,
  ...paginateProps
}) => {
  const thisOnPageChange = React.useCallback(({ selected }) => {
    onPageChange(selected);
  }, [onPageChange]);

  if (!totalPages || totalPages < 2) return null;
  return (
    <ReactPaginate
      pageCount={totalPages || 1}
      forcePage={currentPage || 0}
      onPageChange={thisOnPageChange}
      marginPagesDisplayed={2}
      pageRangeDisplayed={5}
      previousLabel="пред."
      nextLabel="след."
      breakLabel="..."
      breakClassName="break-me"
      containerClassName="pagination"
      pageLinkClassName="pageLink"
      subContainerClassName="pages pagination"
      activeClassName="active"
      {...paginateProps}
    />
  );
});

SimplePaginate.displayName = 'SimplePaginate';
